import "./_detail-panel.scss";

/**
 * The design's blurred "Details" field-grid panel - a company's,
 * subscription's, or market's read-only summary card, sitting one level
 * inside a detail page's `PageHeaderBar`. Renders each field as a
 * label+value pair in a responsive grid; `children` is an escape hatch for
 * content that doesn't fit the label/value shape (e.g. Market's sanitized
 * HTML description).
 *
 * Read-only only, deliberately - the design's own inline whole-record
 * draft editor has no field validation or permission-gating, so this
 * restyle keeps editing on each entity's existing modal/route-based form
 * instead of reproducing that.
 *
 * `fields`: [{ label, value, mono?, tone? }]. `mono` renders the value in
 * JetBrains Mono (ids, amounts). `tone` colors the value
 * ("green"/"red"/"amber"/undefined -> neutral), matching StatCards' own
 * tone vocabulary.
 */
const DetailPanel = ({ title, fields = [], children, className = "" }) => (
  <div className={`detail-panel ${className}`.trim()}>
    {title && <div className="detail-panel__title">{title}</div>}
    <div className="detail-panel__surface">
      {fields.length > 0 && (
        <div className="detail-panel__grid">
          {fields.map((f, idx) => (
            <div className="detail-panel__field" key={f.label ?? idx}>
              <span className="detail-panel__label">{f.label}</span>
              <span
                className={`detail-panel__value detail-panel__value--${f.tone || "neutral"}${
                  f.mono ? " detail-panel__value--mono" : ""
                }`}
              >
                {f.value}
              </span>
            </div>
          ))}
        </div>
      )}
      {children}
    </div>
  </div>
);

export default DetailPanel;
